<!-- InfoListCard.vue -->
<script setup lang="ts">
import Card from 'primevue/card'
import Divider from 'primevue/divider'
const props = defineProps<{ title: string; items: { label: string; value: string }[] }>()
</script>

<template>
  <Card class="mb-3">
    <template #title>{{ title }}</template>
    <template #content>
      <ul class="list-none p-0 m-0 text-sm">
        <li v-for="(it, i) in items" :key="i" class="flex justify-between py-2">
          <span class="text-color-secondary">{{ it.label }}:</span>
          <span class="font-medium">{{ it.value }}</span>
        </li>
        <Divider v-if="items.length" class="my-1" />
      </ul>
    </template>
  </Card>
</template>
